export function getAirtableConfig() {
	return {
	  apiKey: process.env.REACT_APP_AIRTABLE_API_KEY,
	  baseId: process.env.REACT_APP_AIRTABLE_BASE_ID,
	};
  }
  
  export function getAllUrlParams() {
	const urlParams = new URLSearchParams(window.location.search);
	const params = {
	  doors: [],
	  firstName: urlParams.get('firstName') || '',
	  lastName: urlParams.get('lastName') || '',
	  email: urlParams.get('email') || '',
	  phone: urlParams.get('phone') || '',
	  address: urlParams.get('address') || '',
	  city: urlParams.get('city') || '',
	  postalCode: urlParams.get('postalCode') || '',
	  country: urlParams.get('country') || '',
	  timeline: urlParams.get('timeline') || '1-3 Months',
	  message: urlParams.get('message') || '',
	  smsConsent: urlParams.get('smsConsent') === 'true',
	  marketingConsent: urlParams.get('marketingConsent') === 'true',
	  step: urlParams.get('step') || '1',
	};
  
	let doorIndex = 0;
	while (urlParams.get(`door${doorIndex}_doorType`) !== null) {
	  const doorParams = {
		doorType: urlParams.get(`door${doorIndex}_doorType`) || '',
		heightFt: urlParams.get(`door${doorIndex}_heightFt`) || '0',
		heightIn: urlParams.get(`door${doorIndex}_heightIn`) || '0',
		widthFt: urlParams.get(`door${doorIndex}_widthFt`) || '0',
		widthIn: urlParams.get(`door${doorIndex}_widthIn`) || '0',
		slideDirection: urlParams.get(`door${doorIndex}_slideDirection`) || '',
		openingDirection: urlParams.get(`door${doorIndex}_openingDirection`) || '',
		pocketDoor: urlParams.get(`door${doorIndex}_pocketDoor`) || '',
		screen: urlParams.get(`door${doorIndex}_screen`) || '',
		interiorColor: urlParams.get(`door${doorIndex}_interiorColor`) || '',
		exteriorColorSame: urlParams.get(`door${doorIndex}_exteriorColorSame`) || '',
		exteriorColor: urlParams.get(`door${doorIndex}_exteriorColor`) || '',
		hardwareColor: urlParams.get(`door${doorIndex}_hardwareColor`) || '',
	  };
	  params.doors.push(doorParams);
	  doorIndex++;
	}
  
	if (params.doors.length === 0) {
	  params.doors.push({
		doorType: 'Bi-Fold',
		heightFt: '0',
		heightIn: '0',
		widthFt: '0',
		widthIn: '0',
		slideDirection: '',
		openingDirection: '',
		pocketDoor: '',
		screen: '',
		interiorColor: '',
		exteriorColorSame: '',
		exteriorColor: '',
		hardwareColor: '',
	  });
	}
	return params;
  }
  
  export function calculateSquareFootage(door) {
	const totalHeightInches = parseFloat(door.heightFt) * 12 + parseFloat(door.heightIn);
	const totalWidthInches = parseFloat(door.widthFt) * 12 + parseFloat(door.widthIn);
	return ((totalHeightInches * totalWidthInches) / 144).toFixed(2);
  }
  
  export function buildUrl(params) {
	const searchParams = new URLSearchParams();
	const contactFields = [
	  'firstName',
	  'lastName',
	  'email',
	  'phone',
	  'address',
	  'city',
	  'postalCode',
	  'country',
	  'timeline',
	  'message',
	  'smsConsent',
	  'marketingConsent',
	  'step',
	];
	contactFields.forEach((field) => {
	  if (params[field] !== undefined && params[field] !== '') {
		searchParams.append(field, params[field]);
	  }
	});
	params.doors.forEach((door, index) => {
	  Object.keys(door).forEach((key) => {
		searchParams.append(`door${index}_${key}`, door[key]);
	  });
	});
	return `${window.location.pathname}?${searchParams.toString()}`;
  }
  